import React from 'react';
import SectionHeading from '../ui/SectionHeading';
import ProjectCard from '../ui/ProjectCard';
import useReveal from '../../hooks/useReveal';
import { projects } from '../../data/content';
import './Projects.css';

export default function Projects() {
  const revealRef = useReveal();

  return (
    <section className="projects" id="projects">
      <div className="container reveal" ref={revealRef}>
        <SectionHeading eyebrow="02 · work" title="Featured" accent="Projects" />
        <div className="projects__grid">
          {projects.map((project) => (
            <ProjectCard key={project.title} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
}
